module.exports = __webpack_public_path__ + "static/media/maxDailyLogin_180_270.629e366f.png";